import { render } from "./FAQ.vue?vue&type=template&id=ca86decc&scoped=true&lang=pug"
import script from "./FAQ.vue?vue&type=script&lang=ts"
export * from "./FAQ.vue?vue&type=script&lang=ts"

import "./FAQ.vue?vue&type=style&index=0&id=ca86decc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ca86decc"

export default script